import React from 'react';
//horizontalScroll
import ScrollContainer from 'react-indiana-drag-scroll';
//style
import styles from 'src/asset/scss/style/market.reg.module.scss';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function MarketRegDataFieldList(props) {
    const { type, checked, setChecked } = props;

    /* =============== 항목별 map필터 =============== */
    const listFilter = () => {
        switch(type) {
            case 'category' : return [{name:'차량(125cc 미만)', value:1}, {name:'차량(125cc 초과)', value:2}, {name:'차량 부속품', value:3}, {name:'헬멧', value:4}, {name:'의류', value:5}, {name:'기타', value:6}];
            case 'range' : return  [{name:'업체', value:1}, {name:'멤버', value:2}, {name:'둘 다', value:3}];
            case 'used' : return [{name:'SS등급', value:1}, {name:'S등급', value:2}, {name:'A등급', value:3}, {name:'B등급', value:4}, {name:'V등급', value:5}];
            case 'method' : return [{name:'직거래', value:1}, {name:'택배거래', value:2}];
        }
    }
    /* =============== 항목별 map필터 =============== */
    /* =============== 체크선택 =============== */
    const onSelectHandler = (value) => {
        setChecked({...checked, [type]:value})
    }
    /* =============== 체크선택 =============== */
    /* =============== 체크선택 스타일필터 =============== */
    const checkedFilter = (idx) => {
        switch(type) {
            case 'category' : return checked.category === idx ? styles.selected : null;
            case 'range' : return checked.range === idx ? styles.selected : null;
            case 'used' : return checked.used === idx ? styles.selected : null;
            case 'method' : return checked.method === idx ? styles.selected : null;
        }
    }
    /* =============== 체크선택 스타일필터 =============== */

	return (
        <ScrollContainer horizontal={true} component={`ul`}>
            {listFilter().map((item, idx) => 
                <Element tag={`li`} key={idx} ><Element tag={`button`} anyprop={(e) => {onSelectHandler(item.value);}} className={checkedFilter(idx + 1)}>{item.name}</Element></Element>
            )}
        </ScrollContainer>
	)
}